<div *ngIf="isLoading | async" class="loader-overlay">
  <div class="loader-spinner"></div>
</div>
